export default __webpack_public_path__ + "static/media/use_laptop.208e883a.png";